"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    manualDowngradeKeys: ()=>manualDowngradeKeys
});
const manualDowngradeKeys = {
    FORCE_CDN_PREFIX: 'cdn-force_',
    DISABLE_CDN: 'cdn',
    DISABLE_PWA_CACHE: 'pwa-cache',
    PRODUCT_ENTRY_NO_CDN: 'product-entry',
    PRODUCT_CONFIG_USE_CDN: 'product-config',
    JWT_NO_SSO: 'sso',
    JWT_USE_BACKUP: 'jwt-backup',
    DISABLE_JWT: 'jwt',
    DISABLE_COMPONENTS: 'components',
    DISABLE_COMPONENT_PREFIX: 'component_',
    DISABLE_MATERIALS: 'materials',
    DISABLE_MATERIAL_PREFIX: 'material_',
    GATEWAY_REWRITE_ALL: 'gateway-rewrite-all',
    GATEWAY_HIJACK: 'gateway-hijack',
    GATEWAY_INJECT_HEADER: 'gateway-inject-header'
};
exports.manualDowngradeKeys = __webpack_exports__.manualDowngradeKeys;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "manualDowngradeKeys"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
